import React from "react";
import Card from "../ui/Card";

export const PostsAnalyticsSkeleton: React.FC = () => {
  return (
    <div className="w-full flex flex-col gap-2">
      {/* Visão Geral da Atividade - Pipeline de Conteúdo (Fixo no Topo) */}
      <div className="shrink-0 flex flex-col gap-2 bg-white rounded-xl border border-purple-200 p-3 shadow-xs animate-pulse">
        <div className="flex items-center justify-between border-b border-purple-100 pb-2">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 bg-purple-100 rounded-lg shrink-0" />
            <div>
              <div className="h-2.5 w-20 bg-gray-200 rounded-sm mb-1" />
              <div className="h-3.5 w-32 bg-gray-300 rounded-sm" />
            </div>
          </div>
          <div className="h-4.5 w-16 bg-green-100 rounded-full" />
        </div>

        {/* StatsBar Placeholder */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-2 pt-1">
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              className="relative bg-white rounded-xl border border-purple-100 p-2 overflow-hidden flex flex-col justify-between min-h-[60px] shrink-0"
            >
              {/* Colored top accent bar placeholder */}
              <div className="absolute top-0 left-0 right-0 h-[2.5px] bg-purple-100" />

              <div className="flex items-center justify-between gap-1 w-full mt-0.5">
                <div className="space-y-1 flex-1">
                  <div className="h-2 w-10 bg-gray-200 rounded-sm" />
                  <div className="h-3.5 w-6 bg-gray-300 rounded-sm" />
                </div>
                <div className="w-7 h-7 rounded-lg bg-purple-50 shrink-0" />
              </div>
            </div>
          ))}
        </div>
      </div>{" "}
      {/* Nova Grade de Dashboard estruturada em Linhas Horizontais (Esqueleto) */}
      <div className="flex flex-col gap-2 w-full">
        {/* Linha 1: Eficácia da Inteligência (8/12) + Calendário de Distribuição (4/12) */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-2 w-full">
          {/* Seção: Eficácia da Inteligência */}
          <div className="lg:col-span-8 flex flex-col gap-2 bg-white rounded-xl border border-purple-200 p-3 shadow-xs animate-pulse">
            <div className="flex items-start gap-3 border-b pb-2 border-purple-100 mb-3 shrink-0">
              <div className="w-10 h-10 bg-purple-200 rounded-xl shrink-0" />
              <div className="flex-1 min-w-0 h-10 flex flex-col justify-between">
                <div className="h-3.5 w-36 bg-gray-300 rounded-sm" />
                <div className="h-2.5 w-24 bg-gray-200 rounded-sm" />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 items-stretch flex-1">
              {/* Card de IA Gen */}
              <div className="relative overflow-hidden bg-linear-to-br from-indigo-600/80 to-purple-700/80 rounded-xl p-3 shadow-sm flex flex-col justify-between min-h-[140px] h-full">
                <div className="flex items-center gap-2.5 shrink-0">
                  <div className="w-8 h-8 bg-white/20 rounded-lg border border-white/20 shrink-0" />
                  <div className="space-y-1">
                    <div className="h-2 w-16 bg-white/40 rounded-sm" />
                    <div className="h-3 w-12 bg-white/60 rounded-sm" />
                  </div>
                </div>
                <div className="my-1.5 flex-1 flex flex-col justify-center">
                  <div className="h-7 w-12 bg-white/50 rounded-sm" />
                  <div className="h-2.5 w-24 bg-white/40 rounded-sm mt-1.5" />
                </div>
                <div className="bg-white/10 rounded-lg p-1.5 border border-white/10 flex items-center justify-between shrink-0">
                  <div className="h-2 w-12 bg-white/40 rounded-sm" />
                  <div className="h-3 w-8 bg-white/60 rounded-sm" />
                </div>
              </div>

              {/* Card de Taxa de Aprovação */}
              <div className="bg-white rounded-xl border border-purple-200 shadow-xs flex flex-col justify-between p-3 min-h-[140px] h-full">
                <div className="flex items-center justify-between shrink-0">
                  <div className="w-8 h-8 rounded-lg bg-emerald-100" />
                  <div className="space-y-1 flex flex-col items-end">
                    <div className="h-5 w-12 bg-gray-300 rounded-sm" />
                    <div className="h-2 w-10 bg-gray-200 rounded-sm" />
                  </div>
                </div>
                <div className="flex-1 flex flex-col justify-center my-1 space-y-1">
                  <div className="h-3.5 w-24 bg-gray-300 rounded-sm" />
                  <div className="h-2 w-16 bg-gray-200 rounded-sm" />
                </div>
                <div className="shrink-0 space-y-1.5">
                  <div className="w-full h-1.5 bg-gray-100 rounded-full" />
                  <div className="h-2 w-28 bg-gray-200 rounded-sm" />
                </div>
              </div>

              {/* Card de Taxa de Publicação */}
              <div className="bg-white rounded-xl border border-purple-200 shadow-xs flex flex-col justify-between p-3 min-h-[140px] h-full">
                <div className="flex items-center justify-between shrink-0">
                  <div className="w-8 h-8 rounded-lg bg-blue-100" />
                  <div className="space-y-1 flex flex-col items-end">
                    <div className="h-5 w-12 bg-gray-300 rounded-sm" />
                    <div className="h-2 w-10 bg-gray-200 rounded-sm" />
                  </div>
                </div>
                <div className="flex-1 flex flex-col justify-center my-1 space-y-1">
                  <div className="h-3.5 w-24 bg-gray-300 rounded-sm" />
                  <div className="h-2 w-16 bg-gray-200 rounded-sm" />
                </div>
                <div className="shrink-0 space-y-1.5">
                  <div className="w-full h-1.5 bg-gray-100 rounded-full" />
                  <div className="h-2 w-24 bg-gray-200 rounded-sm" />
                </div>
              </div>
            </div>
          </div>

          {/* Calendário de Distribuição */}
          <div className="lg:col-span-4 flex flex-col gap-2 bg-white rounded-xl border border-purple-200 p-3 shadow-xs animate-pulse">
            <div className="flex items-start gap-3 border-b pb-2 border-purple-100 mb-3 shrink-0">
              <div className="w-10 h-10 bg-indigo-100 rounded-xl shrink-0" />
              <div className="flex-1 min-w-0 h-10 flex flex-col justify-between">
                <div className="h-3.5 w-36 bg-gray-300 rounded-sm" />
                <div className="h-2.5 w-24 bg-gray-200 rounded-sm" />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2 shrink-0">
              {[...Array(4)].map((_, idx) => (
                <Card
                  key={idx}
                  variant="default"
                  size="sm"
                  className="border-purple-200! shadow-xs flex flex-col [&>div]:flex-1 [&>div]:flex [&>div]:flex-col [&>div]:justify-between [&>div]:gap-2 min-h-[96px] overflow-hidden"
                >
                  <div className="flex items-center gap-2 shrink-0">
                    <div className="w-8 h-8 rounded-lg bg-gray-200 shrink-0" />
                    <div className="space-y-1">
                      <div className="h-4.5 w-8 bg-gray-300 rounded-sm" />
                      <div className="h-2 w-16 bg-gray-200 rounded-sm" />
                    </div>
                  </div>
                  <div className="mt-1 pt-1.5 border-t border-purple-100 flex items-center justify-between shrink-0">
                    <div className="h-2 w-12 bg-gray-200 rounded-sm" />
                    <div className="flex gap-0.5">
                      <div className="w-1.5 h-1.5 rounded-full bg-gray-200" />
                      <div className="w-1.5 h-1.5 rounded-full bg-gray-200" />
                      <div className="w-1.5 h-1.5 rounded-full bg-gray-200" />
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </div>

        {/* Linha 2: Ranking de Posts (Largura Total - 12/12) */}
        <div className="bg-white rounded-xl border border-purple-200 p-3 shadow-xs animate-pulse gap-2 flex flex-col">
          {/* Header Ranking */}
          <div className="flex flex-wrap items-start justify-between gap-4 border-b border-purple-100 pb-2 mb-3 shrink-0">
            <div className="flex items-start gap-3 flex-1 min-w-0">
              <div className="w-10 h-10 bg-amber-100 rounded-xl shrink-0" />
              <div className="grow min-w-0 h-10 flex flex-col justify-between">
                <div className="h-3.5 w-32 bg-gray-300 rounded-sm" />
                <div className="h-2.5 w-24 bg-gray-200 rounded-sm" />
              </div>
            </div>
            <div className="flex items-center gap-1 self-center">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="h-7 w-16 bg-gray-200 rounded-lg" />
              ))}
            </div>
          </div>

          {/* Pódio Skeletons */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 shrink-0">
            {[
              "border-amber-200 bg-amber-50/10",
              "border-slate-200 bg-slate-50/10",
              "border-orange-200 bg-orange-50/10",
            ].map((style, idx) => (
              <div
                key={idx}
                className={`relative p-4 rounded-xl border-2 flex flex-col justify-between min-h-[140px] ${style}`}
              >
                <div className="flex items-start justify-between mb-2">
                  <div className="w-6 h-6 rounded-full bg-gray-200" />
                  <div className="h-4 w-10 bg-gray-300 rounded-sm" />
                </div>
                <div className="space-y-1.5 flex-1">
                  <div className="h-3.5 w-full bg-gray-200 rounded-sm" />
                  <div className="h-3.5 w-3/4 bg-gray-200 rounded-sm" />
                </div>
                <div className="pt-2 border-t border-purple-100 flex gap-2">
                  <div className="h-2.5 w-10 bg-gray-200 rounded-sm" />
                  <div className="h-2.5 w-10 bg-gray-200 rounded-sm" />
                </div>
              </div>
            ))}
          </div>

          {/* Outros Posts Tabela Skeleton */}
          <Card
            variant="default"
            size="sm"
            className="border-purple-200! overflow-hidden p-0! shadow-xs flex flex-col"
          >
            <div className="px-4 py-2 border-b border-purple-200 bg-purple-50/20 flex items-center justify-between shrink-0">
              <div className="h-3 w-16 bg-gray-300 rounded-sm" />
              <div className="h-3 w-8 bg-gray-200 rounded-sm" />
            </div>
            <div className="divide-y divide-purple-100">
              {[...Array(4)].map((_, idx) => (
                <div key={idx} className="flex items-center gap-3 px-4 py-2.5">
                  <div className="h-3 w-4 bg-gray-200 rounded-sm shrink-0" />
                  <div className="h-3 w-8 bg-purple-100 rounded-sm shrink-0" />
                  <div className="h-3 w-4 bg-gray-200 rounded-sm shrink-0" />
                  <div className="h-3.5 w-full bg-gray-200 rounded-sm" />
                  <div className="h-3.5 w-12 bg-gray-300 rounded-sm shrink-0 ml-auto" />
                </div>
              ))}
            </div>
          </Card>
        </div>

        {/* Linha 3: Performance por Canal (PlatformDashboard Skeletons - 12/12) */}
        <div className="bg-white rounded-xl border border-purple-200 p-3 shadow-xs animate-pulse gap-2 flex flex-col">
          <div className="flex items-start gap-3 border-b pb-2 border-purple-100 mb-3 shrink-0">
            <div className="w-10 h-10 bg-purple-200 rounded-xl shrink-0" />
            <div className="flex-1 min-w-0 h-10 flex flex-col justify-between">
              <div className="h-3.5 w-32 bg-gray-300 rounded-sm" />
              <div className="h-2.5 w-24 bg-gray-200 rounded-sm" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-2">
            {[...Array(4)].map((_, idx) => (
              <Card
                key={idx}
                variant="default"
                size="sm"
                className="border-purple-200! shadow-xs [&>div]:flex [&>div]:flex-col [&>div]:gap-3 w-full"
              >
                <div className="flex items-center justify-between mb-1 shrink-0">
                  <div className="flex items-center gap-2.5">
                    <div className="w-9 h-9 rounded-lg bg-gray-200 shrink-0" />
                    <div className="space-y-1">
                      <div className="h-3.5 w-16 bg-gray-300 rounded-sm" />
                      <div className="h-2.5 w-20 bg-gray-200 rounded-sm" />
                    </div>
                  </div>
                  <div className="space-y-1 flex flex-col items-end">
                    <div className="h-4.5 w-10 bg-indigo-100 rounded-sm" />
                    <div className="h-2 w-12 bg-gray-200 rounded-sm" />
                  </div>
                </div>

                {/* 4 colunas no skeleton também! */}
                <div className="grid grid-cols-2 gap-2 flex-1">
                  {[...Array(4)].map((_, k) => (
                    <div
                      key={k}
                      className="rounded-xl p-3 bg-gray-50 border border-purple-200 min-h-[76px] flex flex-col justify-between"
                    >
                      <div className="h-2 w-14 bg-gray-200 rounded-sm" />
                      <div className="h-4 w-10 bg-gray-300 rounded-sm" />
                    </div>
                  ))}
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostsAnalyticsSkeleton;
